import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.css";

const Nav = () => {
	return (
		<nav style={{ marginTop: "30px" }}>
			<NavLink to="/" exact className="subpage-tab" activeClassName="selected">
				Overview
			</NavLink>

			<a
				href="https://vto.qnmcdn.com/assets/pdf/2027_BFC-SponsorshipOpportunities.pdf?148"
				target="_blank"
				rel="noreferrer"
				className="subpage-tab"
			>
				Sponsorship Opportunities
			</a>

			{/*
      <a
        href="https://vto-qnewmedia2.netdna-ssl.com/assets/pdf/2021_BFC-schedule.pdf?2021"
        target="_blank"
        rel="noreferrer"
        className="subpage-tab"
      >
        BFC Events
      </a>
     
      <NavLink
        to="/events"
        exact
        className="subpage-tab"
        activeClassName="selected"
      >
        BFC Events
      </NavLink>
  */}

			<NavLink
				to="/sponsors"
				className="subpage-tab"
				activeClassName="selected"
			>
				BFC Sponsors
			</NavLink>

			{/*<NavLink to="/venues" className="subpage-tab" activeClassName="selected">
        2023 Venues
</NavLink>*/}
		</nav>
	);
};

export default Nav;
